import axios from "axios";
import {
  BASE_URL,
  DUTY_TYPE_LIST,
  LHB_RECORDS,
  LHBRECORDS_LIST,
  LOGIN,
  LOGOUT,
  MICROACTIVITY_LIST,
  PRODUCT_LIST,
  PROJECT_LIST,
  REMARK_LIST,
  SHIFT_LIST,
  STATION_LIST,
  SUBACTIVITY_LIST,
  TIMESHEET_LHB_RECORDS,
  TIMESHEET_LHB_RECORDS_LIST,
  UNIT_LIST,
} from "./apiConstants";
import { v4 as uuidv4 } from "uuid";

const API = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// API.interceptors.request.use((req) => {
//   if (localStorage.getItem("pt")) {
//     req.headers.token = JSON.parse(localStorage.getItem("pt")).token;
//   }
//   return req;
// });

API.interceptors.request.use((req) => {
  req.headers["key"] = uuidv4();
  req.headers["token"] = uuidv4();
  req.headers["ltk"] = uuidv4();

  return req;
});

// Login API
export const login_api = (loginData) => API.post(`${LOGIN}`, loginData);

// Logout API
export const logout_api = () => API.post(`${LOGOUT}`);

//timesheet lhb records
export const timesheet_lhb_records_list = (pageNum, filtersJSON) =>
  API.get(TIMESHEET_LHB_RECORDS_LIST, {
    params: {
      page: pageNum,
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

export const add_timesheet_records = (bodyData) =>
  API.post(`${TIMESHEET_LHB_RECORDS}`, bodyData);

export const edit_LHB_records = (id, bodyData) =>
  API.patch(`${LHB_RECORDS}/${id}`, bodyData);

export const get_timesheet_records_by_ID = (id) =>
  API.get(`${TIMESHEET_LHB_RECORDS}${id}`);

export const delete_lhb_record_by_ID = (id) =>
  API.delete(`${LHB_RECORDS}/${id}`);
//duty type
export const duty_type_list = (pageNum, filtersJSON) =>
  API.get(DUTY_TYPE_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//shift
export const get_shift_list = (pageNum, filtersJSON) =>
  API.get(SHIFT_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//station
export const station_list = (pageNum, filtersJSON) =>
  API.get(STATION_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//sub activity
export const subActivity_list = (pageNum, filtersJSON) =>
  API.get(SUBACTIVITY_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//micro activity
export const microActivity_list = (pageNum, filtersJSON) =>
  API.get(MICROACTIVITY_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//product
export const product_list = (pageNum, filtersJSON) =>
  API.get(PRODUCT_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });

//project
export const project_list = (pageNum, filtersJSON) =>
  API.get(PROJECT_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON && { filtersJSON }),
    },
  });

//unit listing
export const get_unit_listing = (pageNum, filtersJSON) =>
  API.get(UNIT_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
//remark
export const remark_list = (pageNum) =>
  API.get(REMARK_LIST, {
    params: {
      ...(pageNum && { page: pageNum }),
    },
  });

export const get_lhbRecords_list = () => API.get(LHBRECORDS_LIST);
